import { Scene, TransformNode, Vector3, Mesh } from "@babylonjs/core";

/**
 * A Zone is a logical "place" in the mall — the main atrium, an individual
 * shop interior, etc. Zones live in the same Babylon Scene (all zones are
 * placed at different world-space origins, far apart). The local player
 * teleports between zones via doorway trigger volumes.
 */
export abstract class BaseZone {
  readonly id: string;
  readonly root: TransformNode;
  readonly scene: Scene;
  readonly origin: Vector3;
  entryPosition: Vector3 = new Vector3(0, 1.7, 0);
  entryRotation: number = 0;

  constructor(id: string, scene: Scene, origin: Vector3) {
    this.id = id;
    this.scene = scene;
    this.origin = origin.clone();
    this.root = new TransformNode(`zone-${id}`, scene);
    this.root.position = origin.clone();
  }

  /** Build static geometry. May async-load assets. */
  abstract build(): Promise<void>;

  /** Meshes the player should stand on (for XR teleportation later). */
  floorMeshes(): Mesh[] {
    return [];
  }

  dispose(): void {
    this.root.dispose(false, true);
  }
}
